import React from 'react'
import { number, string } from 'prop-types'
import Loadable from '@loadable/component'
import styled from '@emotion/styled'
import { MapMarker } from './MapMarker'
import { GOOGLE_MAPS_GEOCODING_API_KEY } from '@jelly/utils'

const GoogleMapReact = Loadable(() => import(/* webpackChunkName: 'maps' */ 'google-map-react'))

const MapContainer = styled.div`
	display: block;
	height: ${({ height }) => height};
	position: relative;
	width: ${({ width }) => width};
`

Map.propTypes = {
	/** Specific height of map container */
	height: string,
	/** Latitude coordinate of location */
	latitude: number.isRequired,
	/** Longitute coordinate of location */
	longitude: number.isRequired,
	/** Specific width of map container */
	width: string,
	/** Amount of zoom applied to the map (higher number = closer) */
	zoom: number,
}

/**
 * Map Component, displays a google map with certain coordinates
 * Takes up the entire width and height of parent unless otherwise stated
 * Wrapped in Loadable
 *
 * Default Map: BDC Waltham Location
 */
export function Map({ height = '100vh', latitude = 42.391389, longitude = -71.256516, width = '100vw', zoom = 8 }) {
	return (
		<MapContainer height={height} width={width}>
			<GoogleMapReact
				bootstrapURLKeys={{ key: GOOGLE_MAPS_GEOCODING_API_KEY }}
				defaultCenter={{ lat: latitude, lng: longitude }}
				defaultZoom={zoom}
				center={{ lat: latitude, lng: longitude }}
				zoom={zoom}
			>
				<MapMarker />
			</GoogleMapReact>
		</MapContainer>
	)
}
